import React, { ComponentProps } from "react";

import AsyncSelectPickerInput from "../../components/Common/AsyncSelectPickerInput/AsyncSelectPickerInput";
import type { Option } from "../../interfaces";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { useFieldContext } from "../formContext";

type FormAsyncSelectProps<T> = Omit<ComponentProps<typeof AsyncSelectPickerInput<T>>, "name" | "value" | "onChange">;

/**
 * Adapter: web's `AsyncSelectPickerInput` bound to the current field. The field value must be
 * `Option | null`; `useFieldContext<V>` is not checked against the form. Not wired to blur. The generic
 * `T` (item type of `selectData`) is not inferred through `createFormHook`: via `field.AsyncSelect` it is
 * `unknown` (checked with tsc), so annotate the `prepareOptionFunction` item parameter explicitly.
 */
export const FormAsyncSelect = <T,>(props: FormAsyncSelectProps<T>) => {
  const field = useFieldContext<Option | null>();

  return (
    <>
      <AsyncSelectPickerInput
        {...props}
        name={field.name}
        value={field.state.value}
        onChange={(option) => field.handleChange(option)}
      />
      <FieldErrorMessage />
    </>
  );
};
